import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../../playground/common/auto-form';
import { APV_SELECT_ONE_FIELDS } from './fields';
import { ApvSelectOneResultView } from './result-view';
import {
  ApvSelectOneFormValues,
  ApvSelectOneRegime,
  apvSelectOneDefaults,
  apvSelectOneSchema,
} from './schema';
import { buildApvSelectOnePayload, simulateApvSelectOne } from './service';

export function ApvSelectOnePage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);
  // Pinned at submit time, not read from the live form: the result view must
  // keep describing the regime the response was actually computed under, even
  // if the user flips the selector before re-simulating.
  const [lastRegime, setLastRegime] = useState<ApvSelectOneRegime>(apvSelectOneDefaults.regime);

  const mutation = useMutation({
    mutationFn: (values: ApvSelectOneFormValues) => simulateApvSelectOne(values),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={APV_SELECT_ONE_FIELDS}
            schema={apvSelectOneSchema}
            defaults={apvSelectOneDefaults}
            isLoading={mutation.isLoading}
            onSubmit={(values) => {
              setLastRequest(buildApvSelectOnePayload(values));
              setLastRegime(values.regime);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <ApvSelectOneResultView
          request={lastRequest}
          regime={lastRegime}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
